var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalRecirculationTimebased = function SvgDAhuSignalRecirculationTimebased(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 129,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,119c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M307,118c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z",
    fill: "#1c9d5b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M307,122.14c3.78,0,6.86,3.08,6.86,6.86s-3.08,6.86-6.86,6.86-6.86-3.08-6.86-6.86,3.08-6.86,6.86-6.86M307,121.14c-4.34,0-7.86,3.52-7.86,7.86s3.52,7.86,7.86,7.86,7.86-3.52,7.86-7.86-3.52-7.86-7.86-7.86h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.41,132.29l-2.65-3.16s.03-.08.03-.13c0-.24-.11-.45-.29-.59v-4.12h-1v4.12c-.17.14-.29.35-.29.59,0,.43.35.79.79.79,0,0,0,0,0,0l2.64,3.15.77-.64Z"
  })))));
};
export default SvgDAhuSignalRecirculationTimebased;